<template>
    <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header" id="topHeader">        
        <header-pl></header-pl>
        <div id="content">
            <div class="mdl-grid">
                <div class="mdl-cell mdl-cell--1-col mdl-cell--hide-tablet mdl-cell--hide-phone col-left"></div>
                <div class="mdl-color--white content mdl-color-text--grey-800 mdl-cell mdl-cell--10-col page-content">
                    <router-view :key="$route.fullPath"></router-view>
                </div>
            </div>
        </div>
        <footer-pl ></footer-pl>
        <form-pl :id="'data'"/>
        <popup :id="'popup'"/>
    </div>
</template>

<script>
import HeaderPL from "@/components/HeaderPL"
import FooterPL from "@/components/FooterPL"
import FormPL from "@/components/FormPL"
import Popup from "@/components/PopUp"

export default {
  name:"App",
  components: {
    'header-pl' : HeaderPL,
    'footer-pl' : FooterPL,
    'form-pl' : FormPL,
    'popup' : Popup,
  }
}
</script>

<style>

@import url('https:////fonts.googleapis.com/css?family=Ubuntu+Condensed|Titillium+Web:400,300,300italic,400italic,600,600italic,700,700italic');


#app {
  font-family: "Titillium Web", Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#topHeader {
  height : 100%;
}


.col-left {
	background-image: url("@/assets/images/ProLexisLogo.png");
	background-repeat: no-repeat;
	background-size: calc(max(min(100%, 130px), 66px));
	background-position-y: 10px;
}

.mdl-grid {
  height: 100%;
  box-sizing: border-box;
  padding-bottom: 0;
}


.page-content {
	padding-top: 27px;
	min-height: 50%;
  margin-bottom: 0;
}
@media screen and (min-width:480px) and (max-width:839px) {
	.page-content {
		background-image: url("@/assets/images/ProLexisLogo.png");
		background-repeat: no-repeat;
		background-size: 70px;
		background-position: right 10px;
	}
}



/* COLOR  */
.red {
  color : #cc0b00;
}

.green {
  color : #00aa00;
}


</style>
